import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { useParams } from 'react-router-dom';
import { authenticationService } from '../../components/authorization';
import { FormView, Field } from '../../components/form/Index';
import { GetSAML, GetInfomation } from '../../REST/statement';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReceiptAdd from './receipt';
import MessageView from '../../components/message';
const paymenturl = process.env.REACT_APP_PAYMENT_URL
const paymentsuccessurl = process.env.REACT_APP_API_URL+"/Payment/Success"
const paymentwindow = process.env.REACT_APP_PAYMENT_WINDOW * 60 * 1000
const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExternalPayment({ open = false, handleClose, invoiceId }) {
    const classes = useStyles();

    return (<Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar color='secondary' className={classes.appBar}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                    Payment
                </Typography>
            </Toolbar>
        </AppBar>
        <MessageView setting='PAYMENT_OTHER_WINDOW' title='Payment Message' fullScreen={false} />
    </Dialog>
    );
}

 

export function PaymentView({ }) {
    const classes = useStyles();
  
    const [manual, setManual] = useState(false);
    const { id } = useParams();
    const formView = useRef(null);
    const [user, setUser] = useState(authenticationService.getUserInfo());

    const goPay = ()=>{
        GetInfomation(id).then(resp => { 

            console.log(resp);
            let udf1 = resp.data.id;   
            if(resp.data.temporary==false){
                debugger
                udf1 = resp.data.invoiceNumber; 
            }   else  if(resp.data.temporary==true &&  resp.data.name && resp.data.name.toUpperCase().includes("TRANSIENT") ){                              
               const transientevntid = resp?.data?.applicationId;
               udf1 = transientevntid ? `T${transientevntid}` : resp?.data?.id;

            }   else  if(resp.data.temporary==true){
                udf1 = "permitapp"+resp.data.applicationId; 
            }                   
                    
            const amount = resp.data.amountDue ? resp.data.amountDue :0
            const udf0 = resp.data.id;   
            //const udf1 = accountnum
            const udf2 = resp.data.applicationId
            const udf3 = resp.data.invoiceNumber

             
            //custom2 files how the event id number 
            //general invoice and application 
            //add companyname and vendor code to invoice
            const data = {
                "SOURCE":"GCN",
                "RETURNURL":paymentsuccessurl, "TRANSACTIONAMOUNT":twoDecimalPoint(amount),
                "EMAIL":user.email,"EXPIRES":(new Date()).getTime()+paymentwindow,
                "JSONDATA":{ 
                        "firstname":user.firstName,"lastname":user.lastName,
                        "udf0":udf0,"udf1":udf1,"udf3":udf3
                } 
            }
             

            const token =    btoa(JSON.stringify(data)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            const href= paymenturl+"?token="+token
            Object.assign(document.createElement('a'), {
                rel: 'noopener noreferrer',
                href: href,
              }).click();
        })

    }
 

    const twoDecimalPoint = (num) => {
        return  num.toFixed(2)
    }

    const handleUser = () => {
        let result = formView.current.getResult();
        if (result) {
            setUser(result)
        }
    }

    if (manual)
        return <ReceiptAdd onBack={() => setManual(false)} />

    if (user === null)
        return <div className='row h-100'>
            <div className='sm-offset-6 col-sm-4 col-xs-12'>
                <h4>Please Provide Following Details</h4>
                <FormView ref={formView}>
                    <Field.TextBox label='First Name' field='firstName' required />
                    <Field.TextBox label='Last Name' field='lastName' required />
                    <Field.TextBox label='Email' field='email' required />
                    <Button onClick={handleUser} fullWidth variant='outlined' color='secondary'>Submit</Button>
                </FormView>
            </div>
        </div >

    return <div className='row h-100'>
        <div className='col-12 my-auto text-center'>
                
            <Button variant='outlined' className='mx-auto' onClick={ goPay   }  >Proceed to Payment Portal (External)</Button>
            
            {authenticationService.isAdmin() && <Button className='mx-auto' onClick={() => setManual(true)} variant='outlined'>Manual Payment</Button>}
        </div>
    </div>
}